import QuizModuleStat from "../../../../../models/QuizStat/QuizModuleStat";

export function getQuizModuleBestMark(quizModuleStat?: QuizModuleStat) {
  return quizModuleStat?.bestSessionMark;
}

export function getQuizModuleMarksTotal(quizModuleStat?: QuizModuleStat) {
  return quizModuleStat?.marksTotal;
}
